import React, { useState } from "react";
import { FaInstagram, FaTiktok, FaFacebook, FaYoutube, FaXTwitter } from "react-icons/fa6";

const PlatformsMarquee = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Define the platforms data for easier duplication
  const platforms = [
    {
      icon: FaInstagram,
      link: "https://instagram.com/wamae_k"
    },
    {
      icon: FaTiktok,
      link: "https://tiktok.com/@wamae_k"
    },
    {
      icon: FaFacebook,
      link: "https://www.facebook.com/kelvin.wamae.988"
    },
    {
      icon: FaYoutube,
      link: "https://www.youtube.com/@wamae_arts"
    },
    {
      icon: FaXTwitter,
      link: "https://twitter.com/Wamae4art"
    }
  ];

  const renderPlatformItem = (platform, index, isClone = false) => {
    const Icon = platform.icon;
    return (
      <div
        key={`platform-${index}${isClone ? '-clone' : ''}`}
        className="platform-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="platform-content">
          <Icon className="platform-icon" />
          <button className="cta-button">
            <a href={platform.link} target="_blank" rel="noopener noreferrer">
              Follow
            </a>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="platforms-container">
      <h2 className="platforms-heading">Follow me on:</h2>
      <div className="marquee-wrapper">
        <div className={`marquee ${isHovered ? 'paused' : ''}`}>
          {/* First set of items */}
          {platforms.map((platform, index) => renderPlatformItem(platform, index))}
          {/* Duplicate set for seamless loop */}
          {platforms.map((platform, index) => renderPlatformItem(platform, index, true))}
        </div>
      </div>
    </div>
  );
};

export default PlatformsMarquee;